// Security Configuration
export const SECURITY_CONFIG = {
  // API Configuration
  API_BASE_URL: "https://47.activ8.digital/wp-json",
  CONTACT_ENDPOINT: "/custom/v1/contact-form/",
  MENU_ENDPOINT: "/custom/v1/menu",

  // WordPress API Endpoints
  WP_PAGES_ENDPOINT: "/wp/v2/pages",
  WP_PARTNERS_ENDPOINT: "/wp/v2/ourpartnerslider",
  WP_FUTURE_ENDPOINT: "/wp/v2/aboutfutureslider",
  WP_SERVICES_ENDPOINT: "/wp/v2/servicesslider",
  WP_SERVICES_DETAIL_ENDPOINT: "/wp/v2/service_new",

  // Security Settings
  RATE_LIMIT_DURATION: 30000, // 30 seconds
  MAX_RETRIES: 3,

  // CORS Settings
  CORS_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Origin: window.location.origin,
  },

  // Cache Control
  CACHE_CONTROL: {
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
};

// Secure fetcher function with headers
export const secureFetcher = (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: {
      ...SECURITY_CONFIG.CORS_HEADERS,
      ...options.headers,
    },
    credentials: "omit",
  }).then((res) => res.json());
};

// Rate limiting utility
export class RateLimiter {
  constructor(duration = SECURITY_CONFIG.RATE_LIMIT_DURATION) {
    this.duration = duration;
    this.lastCall = 0;
  }

  canProceed() {
    const now = Date.now();
    if (now - this.lastCall < this.duration) {
      return false;
    }
    this.lastCall = now;
    return true;
  }

  getRemainingTime() {
    const now = Date.now();
    const elapsed = now - this.lastCall;
    return Math.max(0, this.duration - elapsed);
  }
}
